import { render, staticRenderFns } from "./BranchStudentsGeneralLearningProgress.vue?vue&type=template&id=4d1570a3&scoped=true&lang=pug&"
import script from "./BranchStudentsGeneralLearningProgress.vue?vue&type=script&lang=ts&"
export * from "./BranchStudentsGeneralLearningProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1570a3",
  null
  
)

export default component.exports